<template>
  <div>
    <div class="md-layout">
      <f-field label="Fecha de orden" :value="order.addDate"></f-field>
      <f-field label="Fecha de entrega" :value="order.deliveryDate"></f-field>
      <f-field label="Condiciones de entrega" :value="order.sendConditions"></f-field>
      <f-field label="Condiciones de pago" :value="order.paymentConditions"></f-field>
    </div>
    <div class="md-layout md-alignment-top-right">
      <div class="md-layout-item md-size-30">
        <h6 class="text-center">Descargar</h6>
        <div class="md-layout">
          <a :href="order.file" target="_blank" class="mx-auto">
            <md-icon class="md-size-2x text-success">picture_as_pdf</md-icon>
          </a>
        </div>
      </div>

      <div v-if="order.campName || order.campAddress" class="md-layout-item md-size-70">
        <f-field v-if="order.campName" label="Campamento" :value="order.campName"></f-field>
        <f-field v-if="order.campAddress" label="Dirección" :value="order.campAddress" :size="50"></f-field>
      </div>
    </div>

    <div class="md-layout">
      <md-table
        class="md-layout-item ml-auto md-size-100"
        id="concepts-table"
        :class="{ 'table-fixed-headers': true }"
      >
        <md-table-row :class="{ 'fixed-headers': true }">
          <md-table-head>Cantidad</md-table-head>
          <md-table-head>Artículo</md-table-head>
          <md-table-head>Descripción</md-table-head>
          <md-table-head>Unidad</md-table-head>
          <md-table-head>Precio Unidad</md-table-head>
          <md-table-head>Precio Total</md-table-head>
        </md-table-row>

        <template v-for="(supply, index) in order.supplies">
          <md-table-row :key="index">
            <md-table-cell md-label="Cantidad">{{ supply.quantity }}</md-table-cell>
            <md-table-cell md-label="Artículo">{{ supply.name }}</md-table-cell>
            <md-table-cell md-label="Descripción">{{ supply.description }}</md-table-cell>
            <md-table-cell md-label="Unidad">{{ supply.unitMeasurement }}</md-table-cell>
            <md-table-cell md-label="Precio Unidad">
              <md-field>
                <md-input
                  v-model="supply.unitPrice"
                  type="number"
                  step="0.01"
                  @change="updateTotal(supply)"
                ></md-input>
              </md-field>
            </md-table-cell>
            <md-table-cell md-label="Precio Total">{{ supply.total | money }}</md-table-cell>
          </md-table-row>
        </template>
      </md-table>
      <div class="md-layout-item ml-right md-size-30">
        <md-button
          :disabled="loading || !filteredSupplies.length"
          class="md-info md-round"
          @click="updateOrder"
        >Guardar cambios</md-button>
        <md-progress-spinner
          v-if="loading"
          :md-diameter="30"
          :md-stroke="5"
          md-mode="indeterminate"
          style="margin-left: 10px"
        ></md-progress-spinner>
      </div>
    </div>
  </div>
</template>

<script>
import FField from "../Quotations/FField";
import purchaseService from "@/services/purchase";
import { cloneDeep } from "lodash";

export default {
  name: "EditOrder",
  components: { FField },
  props: {
    purchaseOrder: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      order: {},
      loading: false,
    };
  },
  computed: {
    filteredSupplies() {
      const { supplies = [] } = this.order;
      return supplies.filter((s) => {
        const found = this.purchaseOrder.supplies.find(
          ({ idOrder }) => idOrder === s.idOrder
        );
        return found && +found.unitPrice !== +s.unitPrice;
      });
    },
  },
  methods: {
    updateOrder() {
      this.loading = true;
      const payload = this.filteredSupplies.map(({ idOrder, unitPrice }) => ({
        buy_order: this.purchaseOrder.id,
        supply: +idOrder,
        unit_price: +unitPrice,
      }));
      purchaseService
        .updatePurchaseOrder(payload)
        .then(() => {
          this.$successMessage({
            text: "Orden de Compra: Precios de insumos actualizados",
          });
          return purchaseService
            .fetchPurchaseOrder(this.order)
            .then((order) => {
              this.order = cloneDeep(order);
              this.$emit("updateOrder", order);
            });
        })
        .catch(this.$fireErrorResponse)
        .finally(() => (this.loading = false));
    },
    updateTotal(supply) {
      supply.total = +supply.unitPrice * supply.quantity;
    },
  },
  watch: {
    purchaseOrder: {
      deep: true,
      handler(newVal) {
        this.order = cloneDeep(newVal);
      },
    },
  },
  mounted() {
    this.order = cloneDeep(this.purchaseOrder);
  },
};
</script>

<style lang="scss" scoped>
.md-button.sin-button .md-ripple {
  padding-left: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/Purchases/PurchaseOrderTracking/EditOrderModal.vue